module.exports = __webpack_public_path__ + "static/media/plaza-1_2-mobile.54e2a5cd.webp";